module.exports = __webpack_public_path__ + "fonts/Latinka-Regular.4ca1a812.ttf";